import React from "react";

function PrivacyPolicy() {
  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Privacy Policy
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="mb-3">Privacy Policy</h1>
            <p className="text-muted">Effective Date: 01.04.2026</p>
          </div>

          <div className="row">
            <div className="col-lg-12">

              <h5 className="mt-4">Introduction</h5>
              <p>
                At Ceylonsman, safeguarding your privacy is a top priority.
                This Privacy Policy explains how we collect, process, store,
                and protect your personal data in accordance with Sri Lanka’s
                Personal Data Protection Act No. 9 of 2022 (PDPA).
              </p>

              <h5 className="mt-4">Data Controller & Registration</h5>
              <p>
                We act as the Data Controller under the PDPA and comply with
                all obligations set forth by the Data Protection Authority of
                Sri Lanka.
              </p>

              <h5 className="mt-4">Personal Data We Collect</h5>
              <ul>
                <li>
                  <strong>Customer-provided information:</strong> Name, contact
                  details, billing info, passport details, travel preferences.
                </li>
                <li>
                  <strong>Automatically collected data:</strong> IP address,
                  browser type, device data, cookies.
                </li>
                <li>
                  <strong>Optional sensitive data:</strong> Health or dietary
                  requirements (only if voluntarily provided).
                </li>
              </ul>

              <h5 className="mt-4">Purpose & Legal Basis</h5>
              <p>
                Your data is used to process bookings, send updates, provide
                invoices, and comply with legal requirements. With your
                consent, we may send promotional content.
              </p>

              <h5 className="mt-4">Data Sharing</h5>
              <p>
                We do not sell or trade your data. Information is shared only
                when necessary for service delivery or legal compliance.
                Third-party websites are not controlled by us.
              </p>

              <h5 className="mt-4">Data Retention & Security</h5>
              <p>
                Data is retained only as long as necessary and then securely
                deleted. We use encryption, secure servers, and strict access
                controls to protect your information.
              </p>

              <h5 className="mt-4">Your Rights Under PDPA</h5>
              <p>
                You may access, update, or delete your data, withdraw consent,
                or lodge complaints with the Data Protection Authority.
              </p>

              <h5 className="mt-4">Cookies & Tracking</h5>
              <p>
                We use cookies to improve experience and analyze usage. You can
                disable cookies in your browser settings.
              </p>

              <h5 className="mt-4">Children’s Data</h5>
              <p>
                Our services are not intended for individuals under 18. We do
                not knowingly collect data from minors.
              </p>

              <h5 className="mt-4">Testimonials</h5>
              <p>
                Testimonials may be displayed without identifiable personal
                data to protect user privacy.
              </p>

              <h5 className="mt-4">Updates to This Policy</h5>
              <p>
                We may update this policy periodically. Changes will be
                reflected with a new effective date.
              </p>

              <h5 className="mt-4">Contact Us</h5>
              <p>
                Email: info@ceylonsman.com <br />
                Address: Ceylonsman (Private) Limited, No: 199/D,
                Kaduwela Road, Oruwala, Athurugiriya (10150), Sri Lanka
              </p>

            </div>
          </div>
        </div>
      </div>
      {/* Privacy End */}
    </div>
  );
}

export default PrivacyPolicy;